/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import TimerWarning from "./timerWarning";
import { Alert } from "@mantine/core";
import { BiInfoCircle } from "react-icons/bi";
import { useSelector } from "react-redux";
import { useAutoAnimate } from "@formkit/auto-animate/react";

const CountdownContent = (props) => {
  let { sale, setItemExpired } = props;
  const { language } = useSelector((state) => ({
    language: state.language,
  }));
  //FirstArticleExpiresAt
  const [timer, setTimer] = useState(undefined);

  //UI time state
  const [timeState, setTimeState] = useState({
    minutes: 0,
    seconds: 0,
  });

  const [timerHasExpired, setTimerHasExpired] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [intervalId, setIntervalId] = useState();

  const [countdownParent] = useAutoAnimate();

  const updateCountdown = () => {
    const currentTime = new Date().getTime();
    const timeUntilCountdownFinishes = timer - currentTime;
    const singleDigitNumbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    let minutes = Math.floor(
      (timeUntilCountdownFinishes % (1000 * 60 * 120)) / (1000 * 60)
    );
    let seconds = Math.floor((timeUntilCountdownFinishes % (1000 * 60)) / 1000);

    if (singleDigitNumbers.includes(minutes)) {
      minutes = `${minutes}`;
    }
    if (singleDigitNumbers.includes(seconds)) {
      seconds = `${seconds}`;
    }
    setTimeState({ minutes: minutes, seconds: seconds });
  };

  //Init timer
  useEffect(() => {
    setTimer(Date.parse(sale.firstArticleExpiresAt));
  }, [sale]);

  //Init tick
  useEffect(() => {
    if (timer && moment().isBefore(timer)) {
      setIntervalId(setInterval(() => updateCountdown(), 1000));
      return () => {
        clearInterval(intervalId);
      };
    }
  }, [timer]);

  //On tick
  useEffect(() => {
    if (timer && moment().isAfter(timer) && !isOpenModal) {
      clearInterval(intervalId);
      if (setItemExpired) {
        setItemExpired(true);
      }
      setTimerHasExpired(true);
      setIsOpenModal(true);
    }
  }, [timer, timeState]);

  if (sale.firstArticleExpiresAt === undefined || timer === undefined) {
    //Don't render control if there is nothing to expire
    return null;
  }

  if (moment(timer).subtract(2, "hours").isAfter(Date.now())) {
    //Dont't render control if it's not time yet
    return null;
  }

  return (
    <div className="countdown-timer-wrapper" ref={countdownParent}>
      {timerHasExpired && (
        <TimerWarning
          isOpenModal={isOpenModal}
          closeModal={setIsOpenModal}
          language={language}
        />
      )}
      {!timerHasExpired && timeState.minutes !== 0 && (
        <div className="countdown-timer-wrapper">
          <Alert
            className="countdown-timer"
            icon={<BiInfoCircle />}
            title={`${language.Countdown_Remaining}`}
            color="red"
            role="timer"
            aria-live="assertive"
            aria-atomic="true"
          >
            <span className="countdown-timer-text">
              {timeState.minutes > 0
                ? `${timeState.minutes} ${language.Minutes}`
                : `${timeState.seconds} ${language.Seconds}`}
            </span>
          </Alert>
        </div>
      )}
    </div>
  );
};

export default CountdownContent;
